query ComplianceRecords($contentId: ID, $productId: ID) {
  complianceRecords(contentId: $contentId, productId: $productId) {
    id
    contentId
    productId
    kind
    performerName
    note
    url
    fileName
    fileUrl
    createdAt
    updatedAt
  }
}
